import { Component, Input, OnInit } from "@angular/core";
import { ViewWillEnter } from "@ionic/angular";
import { ActivatedRoute, Route, Router } from "@angular/router";
import { CustomerProductsService } from "../../../../services/customer-products.service";
import { CustomerProducts } from "../../../../models/customer-products.model";
import { GarmentAddWearerService } from "../../../../services/garment-add-wearer.service";
import { ToasterService } from "../../../../../../common/services/toaster.service";
import { ProductsGarmentsService } from "../../../../services/products-garments.service";
import { ProductVerify } from "../../../../models/product-verify.model";
import { CustomerProductsScheduleService } from "../../../../services/customer-products-schedule.service";
import { CustomerListItem } from "../../../../models/customer-list-item.model";
import { Emblem } from "../../../../models/emblem.model";
import { GtrakAuthService } from "../../../../../../features/authentication/services/gtrak-auth.service";
import { TempCustomerEmployee } from "../../../../models/temp-customer-employee.model";
import { isNullOrUndefined } from "@swimlane/ngx-datatable";

export interface IProductQuantity {
  ProductCode: string;
  Quantity: number;
}

@Component({
  selector: "app-garment-add-wearer-page",
  templateUrl: "garment-add-wearer.page.html",
  styleUrls: [
    "./garment-add-wearer.page.scss",
    "../../../../styles/g-route.styles.scss",
  ],
})
export class GarmentAddWearerPage implements ViewWillEnter, OnInit {
  currentRoute: string;
  stopName: string;

  firstName: string = null;
  lastName: string = null;
  lockerNumber: string = null;
  autoGen: boolean = true;
  productList: CustomerProducts[] = [];
  step: number = 1;
  verifyProducts: ProductVerify[] = [];
  customerList: CustomerListItem[] = [];
  selectedCdCode: string = null;
  userID: string | number = null;
  loaded:Boolean=false;
  breadcrumbs=[];
  products: IProductQuantity[] = [
    { ProductCode: null, Quantity: null },
    { ProductCode: null, Quantity: null },
    { ProductCode: null, Quantity: null },
    { ProductCode: null, Quantity: null },
    { ProductCode: null, Quantity: null },
  ];

  routeStopName: string = "";

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private customerProductsService: CustomerProductsService,
    private customerProductsScheduleService: CustomerProductsScheduleService,
    private garmentAddWearerService: GarmentAddWearerService,
    private productsGarmentsService: ProductsGarmentsService,
    private toasterService: ToasterService,
    private gtrakAuthService: GtrakAuthService
  ) {
    this.currentRoute = null;
  }

  async ngOnInit() {
    this.routeStopName = localStorage.getItem('routeStopName');
    
    this.userID = await this.gtrakAuthService.user.id;

    this.currentRoute = this.router.url;
    this.stopName = this.route.snapshot.paramMap.get("id");
    this.breadcrumbs.push({ label: 'Home', url: '/route' });
    this.breadcrumbs.push({ label: 'Logsheet', url: '/route/logsheet' });
    this.breadcrumbs.push({ label: 'Stop', url: '/route/logsheet/stop/'+ this.stopName });
    await this.getProductList();
    this.loaded=true;
  }
  async getProductList():Promise<void>{
    await this.customerProductsService
    .GetProductList(this.stopName)
    .then((response) => {
      this.productList = response;
    });
    var j=0;
    if(!isNullOrUndefined(this.productList)){
      for(var i=0;i<this.productList.length;i++){
        if(this.products.length > 0 &&  this.productList[i].isDefault){
        this.products[j].ProductCode = this.productList[i].productCode;
        this.products[j].Quantity = this.productList[i].quota;
        j++;
      }
      else{
        break;
      }
     }
   }
  }

  ionViewWillEnter(): void { }

  async moveToStep2(): Promise<void> {
    this.loaded=false;
    //check if no products have been selected
    let count = 0;
    if(!isNullOrUndefined(this.products)){
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].ProductCode === null) {
          count++;
        }
      }
    }
    if (count === 5) {
      this.toasterService.presentToast(
        "danger",
        "Please select at least one product",
        "Error"
      );
      this.loaded=true;
      return;
    }
    //check if products has a product name but no quantity
    if(!isNullOrUndefined(this.products)){
      for (let i = 0; i < this.products.length; i++) {
        if (
          this.products[i].ProductCode !== null &&
          this.products[i].Quantity === null
        ) {
          this.toasterService.presentToast(
            "danger",
            "Please enter a quantity for each product",
            "Error"
          );
          this.loaded=true;
          return;
        }
      }
    }
    //go through each of the products and if there is a null value, change the value to 0
    if(!isNullOrUndefined(this.products)){
      for (let i = 0; i < this.products.length; i++) {
        if (
          this.products[i].ProductCode === null ||
          this.products[i].Quantity === null
        ) {
          this.products[i].ProductCode = "nothing";
          this.products[i].Quantity = 0;
        }
      }
    }
    //grab the data thats necessary for the next page
    await this.productsGarmentsService
      .GetProductList(this.stopName, this.products)
      .then((response) => {
        this.verifyProducts = response; 
        for( let i=0; i < this.verifyProducts.length; i++){
             if(this.verifyProducts[i].emblems.length>0){
              for( let j=0; j < this.verifyProducts[i].emblems.length; j++){
                if(this.verifyProducts[i].emblems[j].isDefault){
                this.verifyProducts[i].selectedEmblems.push( this.verifyProducts[i].emblems[j]);
                }
              }
             }
        }
      });
    //grab the customer and dept codes
    await this.customerProductsScheduleService
      .GetCustomerList(this.stopName)
      .then((response) => {
        this.customerList = response;
        this.selectedCdCode = this.customerList[0]?.cdCode;
      });
    this.step = 2;
    this.loaded=true;
  }

  checkboxAdd(product: ProductVerify, emblem: Emblem, event) {
    if (event.target.checked) {
      product.selectedEmblems.push(emblem);
    } else {
      const index = product.selectedEmblems.indexOf(emblem);
      product.selectedEmblems.splice(index, 1);
    }
  }

  reset(): void {
    this.firstName = null;
    this.lastName = null;
    this.lockerNumber = null;
    this.step = 1;

    this.products.forEach(p => {
      p.ProductCode = null;
      p.Quantity = null;
    });

    this.verifyProducts = [];
    this.getProductList();
  }

  async submit(): Promise<void> {
    //check to make sure all items in verify products have a value in selectedSize
    this.loaded=false;
    if(!isNullOrUndefined(this.verifyProducts)){
      for (let i = 0; i < this.verifyProducts.length; i++) {
        if (
          this.verifyProducts[i].selectedSize === null ||
          this.verifyProducts[i].selectedSize === undefined
        ) {
          this.toasterService.presentToast(
            "danger",
            "Please select a size for each product",
            "Error"
          );
          this.loaded=true;
          return;
        }
        if (
          this.verifyProducts[i].quantity === null ||
          this.verifyProducts[i].quantity === undefined
        ) {
          this.toasterService.presentToast(
            "danger",
            "Please select a quantity for each product",
            "Error"
          );
          this.loaded=true;
          return;
        }
      }
  }
    //check to ensure there is a value selected on selectedCdCode
    if (this.selectedCdCode === null || this.selectedCdCode==undefined) {
      this.toasterService.presentToast(
        "danger",
        "Please select a customer",
        "Error"
      );
      this.loaded=true;
      return;
    }
    //split the selectedCdCode into customerCode and depCode
    const customerCode = this.selectedCdCode.split("/")[0];
    const depCode = this.selectedCdCode.split("/")[1];
    if (this.autoGen !== true) {
      this.garmentAddWearerService
        .LockerCheck(this.lockerNumber, this.stopName, customerCode, depCode)
        .then((response) => {
          if (response === "Locker number already in use") {
            this.toasterService.presentToast(
              "danger",
              "Locker number already in use",
              "Error"
            );
            this.loaded=true;
            return;
          }
        });
    }

    //create the body for the post request
    const body: TempCustomerEmployee = {
      firstName: this.firstName,
      lastName: this.lastName,
      products: this.verifyProducts,
    };

    await this.garmentAddWearerService.AddUser(body, this.stopName, this.lockerNumber, customerCode, depCode, this.userID).then((response) => {
      this.toasterService.presentToast(
        "primary",
        "User added successfully",
        "Success"
      );
      this.reset();
    });
    this.loaded=true;
  }
}
